import React, { useEffect, useState, useCallback, ReactElement } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import './index.less';
import * as Sentry from '@sentry/browser';
import LoadingPage from '../loading-page';

declare let AMap: any;

const AmapApp = ({ children, plugins = [], options = {} }: any) => {
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  // const [toggleHd, setToggleHd] = useState<number>(1);
  useEffect(() => {
    const start = Date.now();
    console.log('开始加载地图元件:' + start);
    AMapLoader.load({
      key: '97005306e21be3a9a88ac7393a26f1ca', // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: plugins, // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      // "AMapUI": {             // 是否加载 AMapUI，缺省不加载
      //     "version": '1.1',   // AMapUI 缺省 1.1
      //     "plugins":[],       // 需要加载的 AMapUI ui插件
      // },
      // "Loca":{                // 是否加载 Loca， 缺省不加载
      //     "version": '1.3.2'  // Loca 版本，缺省 1.3.2
      // },
      ...options
    })
      .then(map => {
        const end = Date.now();
        console.log(
          '加载完成地图元件:' + end + ' 花费:' + (end - start) / 1000 + 's'
        );
        AMap = map;
        setLoading(false);
      })
      .catch(e => {
        const end = Date.now();
        console.log(
          '加载失败地图元件:' + end + ' 花费:' + (end - start) / 1000 + 's, ',
          e
        );
        setError('加载失败');
        Sentry.captureMessage('加载地图组件失败:' + JSON.stringify(e));
      });
  }, []);
  return !error ? (
    loading ? (
      <LoadingPage />
    ) : (
      (children as ReactElement)
    )
  ) : (
    <ErrorCom msg={error} />
  );
};
interface ErrorProps {
  msg: string;
}
const ErrorCom = (props: ErrorProps) => {
  const reload = useCallback(() => window.location.reload(), []);
  return (
    <div className="full-error-wrap">
      <p>
        {props.msg || '系统错误'}, 请点击
        <a className="error-retry" onClick={reload}>
          重试
        </a>
      </p>
    </div>
  );
};

const ChargeLoading = () => {
  return (
    <div className="full-error-wrap">
      <div className="charge-loading-icon"></div>
    </div>
  );
};

export default AmapApp;
